module.exports = __webpack_public_path__ + "img/48.768ae033.png";